import { useTranslation } from 'react-i18next';
import { SUPPORTED_LOCALES, isLocale } from '@blauturquesa/shared/locales';
import { rememberLocale } from '../i18n';

export function LocaleSwitcher() {
  const { t, i18n } = useTranslation();
  return (
    <label className="locale-switcher">
      <span className="visually-hidden">{t('language.label')}</span>
      <select
        value={i18n.language}
        onChange={(e) => {
          const next = e.target.value;
          if (!isLocale(next)) return;
          rememberLocale(next);
          void i18n.changeLanguage(next);
        }}
      >
        {SUPPORTED_LOCALES.map((l) => (
          <option key={l} value={l}>{t(`language.${l}`)}</option>
        ))}
      </select>
    </label>
  );
}
